module.exports = __webpack_public_path__ + "img/Frame 5127.5a0a7825.jpg";